module.exports = __webpack_public_path__ + "static/rust-fd32fc35b465b7bf6b3cb06dc8a84164.png";